import { AUTH_BASE_URL } from "../../../constants";
import { getToken } from "../../../context/authContext";
import { ApiServiceManager, fetchRequest } from "../../apiServiceManager";
import { BANK_PATH } from "./constants";
import {
  IBankDetailsBody,
  IBankDetailsResponse,
  ISupportedBankDetailsResponse,
} from "./model";

const defaultProvide = () => getToken();

export const getBankDetails = (
  userId: string
): Promise<IBankDetailsResponse> => {
  const descriptor = new ApiServiceManager(
    `${AUTH_BASE_URL}/api/users/${userId}/banks`,
    "GET",
    defaultProvide
  );
  return fetchRequest(descriptor);
};

export const updateBankDetails = (
  userId: string,
  body: IBankDetailsBody
): Promise<IBankDetailsResponse> => {
  const descriptor = new ApiServiceManager(
    `${AUTH_BASE_URL}/api/users/${userId}/banks`,
    "POST",
    defaultProvide
  );
  return fetchRequest(descriptor, body);
};

export const getSupportedBanksDetails =
  (): Promise<ISupportedBankDetailsResponse> => {
    const descriptor = new ApiServiceManager(
      `${AUTH_BASE_URL}/${BANK_PATH}`,
      "GET",
      defaultProvide
    );
    return fetchRequest(descriptor);
  };
